import { useStreamingState } from "../../contexts/StreamingState";
import { StreamingState } from "../../types/streamingState";
import { Center } from "../Center";
import styles from "./styles.module.css";

export const LoadingIndicator = () => {
  const { streamingState } = useStreamingState();
  const show = streamingState === StreamingState.waiting;

  return (
    <Center show={show}>
      <div className={styles.container}>
        <div />
        <div />
        <div />
      </div>
    </Center>
  );
};
